var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoppePageDefaultImage1 = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 360 290",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360 0H0v290l89.631-68.472c3.236-2.143 8.479-2.143 11.704 0l23.458 15.559c3.235 2.143 8.478 2.143 11.704 0l100.845-66.875c3.236-2.143 8.479-2.143 11.714 0L360 290V0zM133.476 193.868c-12.026 0-21.781-9.753-21.781-21.765 0-12.013 9.755-21.766 21.781-21.766 12.016 0 21.761 9.753 21.761 21.766 0 12.012-9.745 21.765-21.761 21.765z"
  })));
});
export default SvgDoppePageDefaultImage1;